export default __webpack_public_path__ + "static/media/MarshesMap.73b470b1.jpg";